import { useForm as useFormHook } from "hooks";
import { BooleanSwitchValue } from "consts/general";
import { parse } from "util/parsers";
import { find } from "util/support";
import type { BankingSdkConnector } from "features/openBanking/types";
import {
    FormField,
    type BankingSDKForm,
    type BootstrapData,
    type BankingSDK
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    aisOptions,
    pisOptions,
    flow,
    bankGroup,
    countryISO = '',
    ...restInitialValues
}: Partial<BankingSdkConnector> = {}, bootstrapData: BootstrapData): BankingSDK => ({
    [FormField.AisOptions]: parse(`${aisOptions}`, null),
    [FormField.PisOptions]: parse(`${pisOptions}`, null),
    [FormField.IsEnabled]: BooleanSwitchValue.Off,
    [FormField.Status]: BooleanSwitchValue.Off,
    [FormField.ShouldCreditOnRedirect]: BooleanSwitchValue.Off,
    [FormField.BankGroup]: bankGroup ?? '-' ,
    [FormField.LogoUrl]: null,
    [FormField.CountryIso]: Array.of(countryISO),
    [FormField.Flow]: find(bootstrapData.ConnectorsFlows, 'id')(String(flow)) ?? null,
    [FormField.FullName]: '',
    [FormField.Obs]: '',
    [FormField.OrderNo]: BooleanSwitchValue.Off,
    [FormField.BankId]: BooleanSwitchValue.Off,
    [FormField.RecipientsExist]: false,
    ...restInitialValues
});

export const useForm = (bankingSDKForm: BankingSDKForm) =>
    useFormHook({
        enableReinitialize: true,
        ...bankingSDKForm,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
